import { useQuery } from '@apollo/client';
import {ORDER} from "../orderTypeDefs";

export const useQueryOrder = (options?: any): any => (
  useQuery(ORDER, options)
);
